<template>
  <div class="col-md-5">
    <div class="portlet">
      <div class="portlet-head portlet-head-tab">
        <h3><i class="fas fa-tachometer-alt"></i> Ogłoszenia</h3>
        <ul role="tablist" class="nav nav-tabs" v-if="isEmployOrAdmin">
          <li class="nav-item" v-for="(item, index) in tabs" :key="index">
            <a
              :class="{'nav-link':true, 'nav-basic': true, 'active': item.isActive}"
              v-on:click="showTab(item)"
            >{{item.name}}</a>
          </li>
        </ul>
      </div>
      <div class="portlet-body">
        <div class="announcement-list">
          <button
            class="announcement-add btn btn-outline-primary btn-sm"
            @click="showModal()"
            v-if="canBoardManagment"
          >
            <i class="fas fa-plus"></i> Dodaj
          </button>
          <b-spinner v-if="activeTab.items === false"></b-spinner>
          <div class="h-100" v-else>
            <div class="empty" v-if="activeTab.items.length === 0">
              <i class="empty-state far fa-sticky-note"></i>
              <span class="empty-search">Brak Ogłoszeń</span>
            </div>
            <AnnouncementItem
              v-for="(item, index) in activeTab.items"
              :key="index"
              :announcement="item"
              :editable="canBoardManagment"
              @remove="remove"
              @edit="showModal"
              v-else
            />
          </div>
        </div>
      </div>
    </div>
    <AnnouncementModalForm
      :board="activeTab.board"
      :announcement="selected"
      @onSubmit="handleAppendItem"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AnnouncementsService from "@/services/announcements.service";

import AnnouncementModalForm from "@/components/announcements/AnnouncementModalForm";
import AnnouncementItem from "@/components/announcements/AnnouncementItem";
import dayjs from "dayjs";

export default {
  name: "AnnouncementPortlet",
  components: { AnnouncementModalForm, AnnouncementItem },
  data() {
    return {
      tabs: [
        {
          name: "Pracownicy",
          isActive: false,
          board: "employee",
          items: false
        },
        {
          name: "Podwykonawcy",
          isActive: false,
          board: "subcontractor",
          items: false
        }
      ],
      activeTab: {},
      selected: {}
    };
  },
  computed: {
    ...mapGetters("user", ["isEmployOrAdmin", "isAdmin", "getRole"]),
    canBoardManagment() {
      // return true;
      return (
        (this.isAdmin && this.activeTab.board === "employee") ||
        (this.isEmployOrAdmin && this.activeTab.board === "subcontractor")
      );
    }
  },
  created() {
    if (this.getRole === "subcontractor") {
      this.tabs.shift();
    }
     if (this.getRole === "employee_simple") {
      this.tabs.pop();
    }
    this.showTab(this.tabs[0]);
  },
  methods: {
    showTab(tab) {
      if (this.activeTab) {
        this.activeTab.isActive = false;
        this.activeTab.items = false;
      }
      tab.isActive = true;
      this.activeTab = tab;
      AnnouncementsService.load(this.activeTab.board).then(announcements => {
        this.activeTab.items = announcements;
      });
    },
    showModal(item) {
      this.selected = {};
      if (item) {
        this.selected = item;
      }
      this.$nextTick(() => {
        this.$bvModal.show("announcement-modal");
      });
    },
    handleAppendItem(announcement, isNew) {
      if (isNew) {
        this.showTab(this.activeTab);
      } else {
        if (this.selected.pinned !== announcement.pinned) {
          this.showTab(this.activeTab);
        } else {
          this.$_.each(announcement, (v, k) => {
            if (this.selected[k]) {
              this.selected[k] = v;
            }
          });
        }
      }
      this.$nextTick(() => {
        this.$bvModal.hide("announcement-modal");
      });
    },
    remove(announcement) {
      let h = this.$createElement;
      this.$bvModal
        .msgBoxConfirm(
          [
            h("p", [
              "Czy na pewno chcesz usunąć ogłoszenie ",
              h("br"),
              h("br"),
              h("strong", announcement.fullname),
              " z dnia ",
              h(
                "strong",
                dayjs(announcement.created_at).format("YYYY-MM-DD HH:mm")
              ),
              " ?"
            ])
          ],
          {
            title: "Potwierdź usunięcie ogłoszenia",
            okVariant: "danger",
            okTitle: "TAK",
            cancelTitle: "NIE"
          }
        )
        .then(result => {
          if (result === true) {
            this.$Progress.start();
            AnnouncementsService.delete(announcement.id).then(() => {
              this.showTab(this.activeTab);
            });
            // this.remove();
          }
        });
    }
  }
};
</script>
